import Immutable from 'seamless-immutable'

import * as actions from './actions'

const initialState = Immutable.from({
  screenType: null,
  browserInitialized: false,
})

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.UPDATE_SCREEN_TYPE:
      return state.set('screenType', payload)
    case actions.SET_BROWSER_INITIALIZED:
      return state.set('browserInitialized', payload)
    default:
      return state
  }
}
